import React, {useState} from 'react'
import Confirmation from './Confirmation'
import InputField from './shared/InputField'

export default ({onConfirm, onClose, confirm}) => {
  const [notes, setNotes] = useState(null)
  return (
    <Confirmation
      confirm={confirm || 'Are you sure you want to delete?'}
      buttonClass='is-danger'
      buttonText='Delete'
      onConfirm={() => onConfirm({notes})}
      onCancel={() => setNotes(null)}
      onClose={onClose}>
      <InputField
        value={notes || ''}
        type='textarea'
        name='notes'
        label='Reason for deleting? (optional)'
        onChange={({notes}) => setNotes(notes)}
        rows={2}
      />
    </Confirmation>
  )
}
